import * as React from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    IconButton,
} from "@mui/material";
import { getContractPdc, addPaymentVoucher } from "state/apis";
import { Close as CloseIcon } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { toast } from "react-toastify";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { add } from "dayjs";
import { useNavigate } from "react-router-dom";

export default function Voucher({ open, onClose, editData, editMode, onSubmit }) {
    // console.log("editData: ", editData);
    const theme = useTheme();
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [input, setInput] = React.useState({ pdc: [] });
    const [payload, setPayload] = React.useState({
        propertyId: editData?.propertyId,
        expenseType: editData?.expense_type?.id,
        // unitId: editData?.unitId,
        date: "",
        note: "",
        totalAmount: 0,
        description: "",
    });
    console.log("payload: ", payload);
    let total = 0;

    const appendExpense = async () => {
        setPayload((prevData) => ({
            ...prevData,
            description: editData?.description,
            totalAmount: editData?.amount,
        }));
    };

    const handleChangeDate = (date) => {
        const formattedDate = date.format("YYYY-MM-DD");
        setPayload((prevData) => {
            return {
                ...prevData,
                date: formattedDate,
            };
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setPayload((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        try {
            // Call the API with the updated payload
            console.log("payload: ", payload);
            const response = await addPaymentVoucher(payload);
            toast.success(response.message);

            onSubmit();
            onClose();
            navigate("/payment voucher");
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                Payment Voucher
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} my={"8px"}>
                    <Grid item xs={4} justifyContent={"end"}>
                        <Button
                            variant="contained"
                            onClick={() => appendExpense()}
                            sx={{
                                color: theme.palette.primary.light,
                                backgroundColor: theme.palette.secondary[200],
                            }}
                        >
                            Add Expense
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                            <DatePicker
                                fullWidth
                                label="Select date"
                                name="date"
                                onChange={handleChangeDate}
                                value={payload.date ? dayjs(payload.date) : null}
                                format="DD/MM/YYYY"
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Note"
                            name="note"
                            value={payload?.note}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            type="number"
                            label="Amount"
                            name="totalAmount"
                            value={payload?.totalAmount}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Description"
                            name="description"
                            value={payload?.description}
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>

                <Grid container justifyContent="flex-end" my={2}>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Save
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
